module.exports = __webpack_public_path__ + "static/vignoble_et_decouvertes-953320456a2ffedb56b7d3d3c1de6fc8.png";